<template>
	<div class="c-modal-add-brand">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<template v-slot:title>
				<h2>Track a brand</h2>
			</template>
			<template>
				<article class="article-text-sm">
					<p>
						<strong> Two ways to track a brand </strong>
					</p>
					<p>Search for a existing brand on the Swipekit platform.</p>
					<p>
						Or paste the Facebook ad library url of the brand(Here's an
						<a
							href="https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&media_type=all&search_type=page&view_all_page_id=1978160732305312"
							target="_blank"
						>
							example</a
						>
						url)
					</p>
				</article>
				<Track @onSubmit="onSubmit"></Track>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';
import FormBrandCreate from '@swipekit/components/form/form-brand-create.vue';
import Track from '@swipekit/components/brands/track.vue';

export default {
	components: {
		Modal,
		FormBrandCreate,
		Track,
	},

	data: function () {
		return {
			options: {
				active: false,
			},
		};
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		addBrand: function () {
			if (this.addBrand) {
				this.options.active = true;
			} else {
				this.options.active = false;
			}
		},
	},

	computed: {
		addBrand: function () {
			return this.$store.getters['app/addBrand'];
		},
	},

	methods: {
		onSubmit: function () {
			window.location.reload();
			this.options.active = false;
		},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			this.$store.dispatch('app/setAddBrand', false);
		},
	},

	mounted: function () {
		//this.options.active = true;
	},
};
</script>

<style lang="scss">
.c-modal-add-brand {
	.modal__content {
	}
}
</style>
